import { Button } from '@kerfjs/ui/button';
import { List } from '@kerfjs/ui/list';
import { ListHeader } from '@kerfjs/ui/list-header';
import { ListItem } from '@kerfjs/ui/list-item';
import { DialogSurface } from '@kerfjs/ui/surface-scaffold';
import { attr, type SafeHtml } from 'kerfjs';

import { libraryProjects } from '../../../data/state.js';

export const NEW_CHAT_DIALOG_ACTIONS = {
  dialog: attr('data-action', 'new-chat-dialog'),
  cancel: attr('data-action', 'new-chat-cancel'),
  pick: attr('data-action', 'new-chat-pick'),
} as const;

/** Choose an organization or project chat. */
export function NewChatDialog(): SafeHtml {
  return (
    <DialogSurface
      label="Start a New Chat"
      className="new-chat-dialog"
      lightDismiss
      rootAttributes={{ 'data-action': NEW_CHAT_DIALOG_ACTIONS.dialog.value, 'data-auto-open-dialog': '' }}
      footer={
        <Button
          emphasis="plain"
          action={NEW_CHAT_DIALOG_ACTIONS.cancel.value}
          rootAttributes={{ 'data-dialog-close': '' }}
        >
          Cancel
        </Button>
      }
    >
      <List>
        <ListHeader label="Across the Organization" />
        <ListItem
          label="Organization Chat"
          description="Search retained demands and outcomes"
          action="new-organization-chat"
        />
        <ListHeader label="Within a Project" />
        {libraryProjects.value.map((project) => (
          <ListItem
            label={project.name}
            action={NEW_CHAT_DIALOG_ACTIONS.pick.value}
            itemId={project.id}
            rootAttributes={{ 'data-key': project.id }}
          />
        ))}
      </List>
    </DialogSurface>
  );
}
